import React from 'react';
import { Box, Button, Modal, TitleText, ButtonMode, Text } from 'edenred-ui';
import { useTheme } from 'styled-components';

import { ICloseDetailVirike } from '@epi-models/containers/ManageBenefitGroups';
import { useTranslation } from 'react-i18next';

export const CloseBenefitDetailModal = ({
  isOpen,
  handleCloseModal,
  handleSubmit,
  isSubmitAndShowRedirectConfirmation
}: ICloseDetailVirike) => {
  const { sizeMedium, gray85, fontBold } = useTheme();
  const { t } = useTranslation();

  const titleText = isSubmitAndShowRedirectConfirmation
    ? t('components.load_benefit_popup.title')
    : t('components.exit_popup.title');

  const text = isSubmitAndShowRedirectConfirmation ? (
    <Text paragraph>{t('components.load_benefit_popup.text')}</Text>
  ) : (
    <Text paragraph>{t('components.exit_popup.text')}</Text>
  );

  const submitText = isSubmitAndShowRedirectConfirmation
    ? t('components.load_benefit_popup.submit')
    : t('components.exit_popup.submit');

  const cancelText = isSubmitAndShowRedirectConfirmation
    ? t('components.load_benefit_popup.cancel')
    : t('components.exit_popup.cancel');

  return (
    <Modal open={isOpen} onClose={handleCloseModal}>
      <Box>
        <TitleText color={gray85} fontSize={sizeMedium} fontWeight={fontBold}>
          {titleText}
        </TitleText>
      </Box>
      <Box width={305} mb={3}>
        {text}
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={3}
      >
        <Button onClick={handleSubmit} id="delete-button">
          {submitText}
        </Button>
        <Button
          onClick={handleCloseModal}
          mode={ButtonMode.Link}
          id="cancel-delete-button"
        >
          {cancelText}
        </Button>
      </Box>
    </Modal>
  );
};
